import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/GetHistogramConstant';
import restClient from '../../../routers/MainFrame/action/APIClient';
import LogoutConstant from '../../../routers/MainFrame/constants/Constants';
import _ from "lodash";

var moment = require('moment');
var organization, country, locality, area, profileId, granularity = 'weekly';
var dateRange = {}, filters = {};

var PhotosTypeCountAction = function () {

}

PhotosTypeCountAction.prototype = {

	addFilters: function (data, newGranularity) {
		filters = data;
		granularity = newGranularity;
		this.loadData();
		this.loadDataCustomer();
	},

	clearFilters: function () {
		filters = {};
		granularity = 'weekly';
	},

	changeProfile: function (value) {
		profileId = value;
		this.loadData();
		this.loadDataCustomer();
	},

	addDownloadFilters: function (data) {
		if (data.profileId) {
			profileId = data.profileId;
			delete data.profileId
		}
		// if(data.granularity){
		// 	granularity = data.granularity;
		// 	delete data.granularity;
		// }
		filters = data;
		this.loadData();
		this.loadDataCustomer();
	},

	changeOrganisation: function (value) {
		organization = value;
		this.loadData();
		this.loadDataCustomer();
	},

	addCountry: function (value) {
		country = value;
		locality = undefined;
		area = undefined;
		this.loadData();
		this.loadDataCustomer();
	},

	addArea: function (value) {
		area = value;
		locality = undefined;
		this.loadData()
		this.loadDataCustomer();;
	},

	addLocality: function (value) {
		locality = value;
		this.loadData();
		this.loadDataCustomer();
	},

	addDates: function (fromDate, toDate) {
		dateRange.from = fromDate;
		dateRange.to = toDate;
		this.loadData();
		this.loadDataCustomer();
	},

	loadData: function () {
		if (!(filters.hasOwnProperty('dateRange'))) {
			dateRange.from = moment().subtract(16, 'week').format('YYYY-MM-DD');
			dateRange.to = moment().format('YYYY-MM-DD');
			filters['dateRange'] = dateRange;
		}

		filters['insightFilters'] = {
			"metrics": [
				"PHOTOS_VIEWS_MERCHANT",
				"PHOTOS_COUNT_MERCHANT"
			]
		}

		var data = {
			granularity: filters.granularity || granularity,
			profileId: localStorage.getItem('profileId'),
			filters: _.clone(filters)
		};

		restClient.getLocationInsightMetricCount(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.PHOTOS_TYPE_RESPOSNE,
					data: response
				});
			}

		})
	},
	loadDataCustomer: function () {
		if (!(filters.hasOwnProperty('dateRange'))) {
			dateRange.from = moment().subtract(16, 'week').format('YYYY-MM-DD');
			dateRange.to = moment().format('YYYY-MM-DD');
			filters['dateRange'] = dateRange;
		}

		filters['insightFilters'] = {
			"metrics": [
				"PHOTOS_VIEWS_CUSTOMERS",
				"PHOTOS_COUNT_CUSTOMERS"
			]
		}

		var data = {
			granularity: filters.granularity || granularity,
			profileId: localStorage.getItem('profileId'),
			filters: filters
		};

		restClient.getLocationInsightMetricCount(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.PHOTOS_TYPE_RESPOSNE_CUSTOMER,
					data: response
				});
			}
		})
	}
}

export default new PhotosTypeCountAction();